import versionFile from "../app-version.json";

/** Marketing version shared by the native shell and the website label. */
export const APP_VERSION: string = versionFile.version;

/** Dataset key the native shell sets before the hosted page renders. */
export const NATIVE_APP_VERSION_DATASET_KEY = "awardPartyAppVersion";

const MARKETING_VERSION = /^v?\d+\.\d+\.\d+(?:[-+][A-Za-z0-9.-]+)?$/;

export function formatAppVersion(version: string): string {
  const trimmed = version.trim();
  if (!trimmed) {
    return "";
  }

  return trimmed.startsWith("v") ? trimmed : `v${trimmed}`;
}

export function normalizeAppVersion(
  value: string | null | undefined,
): string | null {
  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  if (!MARKETING_VERSION.test(trimmed)) {
    return null;
  }

  return trimmed.startsWith("v") ? trimmed.slice(1) : trimmed;
}

export function resolveDisplayedAppVersion(
  nativeVersion: string | null | undefined,
  fallback: string = APP_VERSION,
): string {
  return normalizeAppVersion(nativeVersion) ?? normalizeAppVersion(fallback) ?? "";
}

export function readDisplayedAppVersion(): string {
  const fromShell = document.documentElement.dataset[NATIVE_APP_VERSION_DATASET_KEY];
  return resolveDisplayedAppVersion(fromShell);
}
